module.exports = __webpack_public_path__ + "static/media/business.6fd78ab6.jpg";